import { Caption } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IDescriptionProps {
  description: string;
}

export const Description: React.FC<IDescriptionProps> = ({ description }) => {
  return (
    <Caption color="surface-neutral-pressed">
      <span className={styles['text']}>{description}</span>
    </Caption>
  );
};
